export default __webpack_public_path__ + "99b5f75f72ba7eb81217ae2ac547e5ee.svg";